import React, { useState, useEffect, useContext } from "react"

import { Formik, Form } from "formik"
import * as Yup from "yup"

//style
import styles from "../../../styles/Form-Inputs.module.css"
import refStyles from "../../../styles/Referrals.module.css"

//PrimeReact
import { Dialog } from "primereact/dialog"
import RefTextAreaInput from "../../Partner/Components/Input/RefTextAreaInput"
import { Button } from "primereact/button"
import RefDropDown from "../../Partner/Components/Input/RefDropDown"

//Referal modules
import { refApiRefEntityStatusPut } from "../ReferralsAPI"
import { getNotePayload } from "./sharedFunctions"

//graphQL
import { useMutation } from "@apollo/client"
import { UPDATE_REFERRAL_STATUS } from "../queries"

// Context
import { UserContext } from "../../../context/userContext"
import { LogError } from "../../../helpers/logger"

export default function ReferralEntityStatusPopup({
  showEntityStatusUpdate,
  setShowEntityStatusUpdate,
  referralEntityId,
  referralId,
  referralOrganizationId,
  setRefStatus,
  referralCreatorStaffId,
  referralParticipantId,
  referralOrganizationID,
  currentEntityStatus,
  currentReferralStatus,
  currentReferralParticipantNote,
}) {
  const userCtx = useContext(UserContext)
  const [errorMessage, setErrorMessage] = useState("")

  const [updateReferral] = useMutation(UPDATE_REFERRAL_STATUS, {
    variables: {
      referral_status: "",
      referral_participants_notes: "",
      user_type: "",
      idStamp: "",
    },
  })

  useEffect(() => {
    if (showEntityStatusUpdate === false) {
      setErrorMessage("")
    }
  }, [showEntityStatusUpdate])

  const handleSubmit = async (values) => {
    try {
      if (values.status !== currentEntityStatus) {
        const submitValues = {
          referralId: values.referralId,
          ReferralEntityId: values.referralEntityId,
          ReferralEntityStatus: values.status,
          UserId: userCtx.session.user.staff_id,
          note: values.note,
          referralEntityStatusOld: currentEntityStatus,
          notePayload: values.notePayload,
          referralCreatorUserId: referralCreatorStaffId || "",
          participantId: referralParticipantId || "",
          referralOrganization: referralOrganizationID || "",
        }

        let newReferralStatus = ""

        switch (values.status) {
          case "Pending":
          case "Accepted":
          case "In Process":
            newReferralStatus = "Active referral"
            break
          case "Complete":
            newReferralStatus = "Completed referral"
            break
          default:
            throw new Error("Unknown status")
        }

        if (
          currentReferralStatus !== newReferralStatus &&
          !(
            currentReferralStatus === "Incomplete referral" &&
            newReferralStatus === "Completed referral"
          )
        ) {
          const updateResult = await updateReferral({
            variables: {
              staff_id: userCtx.session.user.staff_id,
              organization_id: userCtx.session.user.organization_id,
              referral_status: newReferralStatus,
              referral_participants_notes: currentReferralParticipantNote,
              user_type: "partner",
              idStamp: referralId,
            },
          })

          if (!updateResult && !updateResult.data.updateBlockReferral) {
            throw new Error("Unable to update Referral status")
          }
        }

        const partnerStatusResult = await refApiRefEntityStatusPut(
          userCtx.tokens.getMainToken(),
          submitValues,
        )

        if (!!partnerStatusResult) {
          setRefStatus(values.status, newReferralStatus, values.note)
          setShowEntityStatusUpdate(false)
        } else {
          throw new Error(
            "Something went wrong while saving the partner status update",
          )
        }
      }
    } catch (error) {
      LogError("Unable to submit status update", error)
      userCtx.setNotificationError("Unable to submit status update")
    }
  }

  const validationSchema = Yup.object().shape({
    note: Yup.string().required("Please enter a note for the status update"),
  })

  const refEntityStatusOptions = [
    "Pending",
    "Accepted",
    "In Process",
    "Complete",
  ]

  return (
    <>
      <Dialog
        header={"Partner status update"}
        visible={showEntityStatusUpdate}
        onHide={() => {
          setShowEntityStatusUpdate(false)
        }}
        style={{ width: "30vw", height: "445px" }}
      >
        <div>
          {errorMessage !== "" ? (
            <label className={styles.errFieldMsg}>{errorMessage}</label>
          ) : null}
        </div>
        <Formik
          validationSchema={validationSchema}
          initialValues={{
            note: "",
            referralId: referralId,
            referralEntityId: referralEntityId,
            organization_id: referralOrganizationId,
            status: currentEntityStatus,
            notePayload: getNotePayload(userCtx),
          }}
          enableReinitialize
          onSubmit={(values) => {
            handleSubmit(values)
          }}
        >
          {({ handleSubmit, isValid, isSubmitting, dirty, values, errors }) => (
            <Form onSubmit={handleSubmit}>
              <RefDropDown
                name="status"
                label="Partner status"
                placeholderText="Partner status"
                options={refEntityStatusOptions}
                disabled={isSubmitting}
              />
              <div className="p-fluid" style={{ height: "200px" }}>
                <RefTextAreaInput
                  name="note"
                  placeholderText="Note"
                  style={{ bottom: "0" }}
                  disabled={isSubmitting}
                />
              </div>

              <div className={refStyles.footerNoBg}>
                <div
                  className={
                    refStyles.footerNoBg + " " + refStyles.buttonContainerFull
                  }
                  style={{ marginTop: "15px" }}
                >
                  <Button
                    label="Save"
                    icon="pi pi-check"
                    type="submit"
                    disabled={!dirty}
                    loading={isSubmitting}
                    style={{ marginRight: "0.5rem", width: "115px" }}
                    className={refStyles.button}
                  />
                  <Button
                    label="Cancel"
                    icon="pi pi-times"
                    type="button"
                    className={refStyles.button}
                    onClick={() => {
                      setShowEntityStatusUpdate(false)
                    }}
                    style={{ width: "115px" }}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Dialog>
    </>
  )
}
